// Contact information
export const CONTACT_EMAIL = "contact@agentframer.com";

// Social links
export const SOCIAL_LINKS = {
  email: `mailto:${CONTACT_EMAIL}`,
} as const;

// Company info
export const COMPANY_NAME = "AgentFramer";
export const COMPANY_DOMAIN = "agentframer.com";
